export const PORTAL_BILLING_LIFECYCLE_VERSION = 2
